<template>
  <div class="publishing-create-from-design">
    <div class="header">
      <h1>{{ $t('PUBLISHING.CREATE.FROM_EXISTING.HEADING') }}</h1>
      <p>{{ $t('PUBLISHING.CREATE.FROM_EXISTING.SUBHEADING') }}</p>
    </div>
    <div class="design-list">
      <ul v-if="!loading && designs.length">
        <li v-for="design in designs" :key="design.id">
          <Tile
            :name="design.name"
            icon="download-file"
            clickable
            :image="design.resources[0].href"
            image-overlay-icon="plus"
            class="design-tile"
            :display-status="false"
            @on-click="() => designSelected(design)"
          />
        </li>
      </ul>
      <LoadingHeart v-else />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import LoadingHeart from 'commons/LoadingHeart/LoadingHeart.vue';
import designService from 'commons/api/designService/designService';
import publishingCoreService from 'commons/api/publishingCoreService/publishingCoreService';
import Tile from 'commons/tileView/Tile.vue';
import { usePublishingStore } from 'commons/stores/publishing';

export default {
  name: 'PublishingCreateFromDesign',
  components: {
    Tile,
    LoadingHeart,
  },
  props: {},
  emits: ['onDone'],
  data() {
    return {
      loading: true,
      designs: [],
      count: null,
      limit: 20,
      offset: 0,
    };
  },
  computed: {
    ...mapState(usePublishingStore, ['currentScope']),
  },
  watch: {},
  async created() {
    await this.fetchDesigns();
  },
  methods: {
    async fetchDesigns() {
      const res = await designService.getDesigns({
        limit: this.limit,
        offset: this.offset,
      });
      this.designs = res.designs;
      this.count = res.count;
      this.loading = false;
    },
    async designSelected(design) {
      await publishingCoreService.createCompositionFromDesignIdWithScope(
        design.id,
        this.currentScope,
      );
      this.$emit('onDone');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/constants';

.publishing-create-from-design {
  min-width: 700px;
  .header {
    text-align: center;
    margin: 0 0 16px 0;

    h1 {
      margin: 0 0 16px 0;
    }

    p {
      margin: 0;
      color: $grey60;
    }
  }

  .design-list {
    background-color: $grey5;
    padding: 24px;
    border-radius: $border-radius-medium;

    ul {
      list-style: none;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      grid-gap: 24px;
      padding: 0 0 24px 0;
      margin: 0;
    }
  }
}
</style>
